import { ActionIcon, Group } from '@mantine/core';
import { ContactPoint } from '@medplum/fhirtypes';
import { IconPhone, IconTrash } from '@tabler/icons-react';
import { FaxEditableField, SmartEditableField } from '@/components/EditableField';
import { SystemIcon } from './SystemIcon';
import classes from './PartnerEditDrawer.module.css';

interface TelecomEntryProps {
  entry: ContactPoint;
  index: number;
  actualIndex: number;
  onUpdate: (actualIndex: number, value: string) => void;
  onDelete: (actualIndex: number) => void;
  options?: {
    dynamicSystem?: boolean;
    placeholder?: string;
    ariaLabel?: string;
  };
}

export function TelecomEntry({ entry, index, actualIndex, onUpdate, onDelete, options = {} }: TelecomEntryProps) {
  const { dynamicSystem = true, placeholder, ariaLabel } = options;

  const defaultPlaceholder = `Set ${entry.system ?? 'value'}`;
  const defaultAriaLabel = `Delete ${entry.system === 'fax' ? 'fax number' : 'contact method'}`;

  return (
    <Group
      key={entry.id ?? `${entry.system}-${index}`}
      gap="xs"
      justify="space-between"
      wrap="nowrap"
      w="100%"
      className={classes.aboutRow}
    >
      <Group gap="xs" wrap="nowrap" style={{ flex: 1, minWidth: 0, width: '100%' }}>
        <SystemIcon system={entry.system} value={entry.value} fallback={IconPhone} />
        {entry.system === 'fax' ? (
          <FaxEditableField
            value={entry.value ?? ''}
            placeholder={placeholder ?? '+18136056242'}
            inputProps={{ size: 'xs', style: { width: '100%' } }}
            editable
            onSubmit={(val) => {
              onUpdate(actualIndex, val);
            }}
          />
        ) : (
          <SmartEditableField
            value={entry.value ?? ''}
            placeholder={placeholder ?? defaultPlaceholder}
            inputProps={{ size: 'xs', style: { width: '100%' } }}
            editable
            dynamicSystem={dynamicSystem}
            onSubmit={(val) => {
              onUpdate(actualIndex, val);
            }}
          />
        )}
      </Group>
      <ActionIcon
        onClick={() => onDelete(actualIndex)}
        variant="subtle"
        color="red"
        size={16}
        radius="md"
        className={classes.showOnHover}
        aria-label={ariaLabel ?? defaultAriaLabel}
      >
        <IconTrash size={14} />
      </ActionIcon>
    </Group>
  );
}
